export default "__VITE_ASSET__CYFyX8hF__"